import { h, Component } from 'preact'
import styled from 'styled-components'
import latinize from 'latinize'
import Sizer from '../../components/atoms/sizer'
import VSpace from '../../components/atoms/vspace'
import ResultCard from './resultcard'
import ResultCardContainer from './resultcardcontainer'
import Spinner from '../../components/atoms/spinner'
import Select from '../../components/atoms/select/select'
import Input from '../../components/atoms/input'
import ArrowCheckbox from '../../components/atoms/checkbox/arrowCheckbox'
import fetcher from '../../utils/fetcher'
import inParliament from './in-parliament.png'
import crossBlack from './cross-black.png'
import tickBlack from './tick-black.png'
import { getType } from '../../data/index.mjs'

/* global history */
/* eslint-disable react/no-unused-state, no-restricted-globals */

function replaceState(a, b, c) {
  if (typeof history !== 'undefined') {
    history.replaceState(a, b, c)
  }
}

const Filters = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`

const NameInput = Input.extend`
  margin-left: 20px;
  display: inline-block;
  width: 308px;
`

const Title = styled.p`
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 24px;
`

function votesToParties(v) {
  const partyCounts = {}
  return v
    .map(a => a.party)
    .filter((value, index, self) => {
      if (!partyCounts[value]) partyCounts[value] = 0
      partyCounts[value] += 1
      return self.indexOf(value) === index
    })
    .map(party => ({ party, count: partyCounts[party] }))
}

const InParliament = styled(p => (
  <div {...p}>
    <img src={inParliament} alt="Tito už jsou ve sněmovně" />
  </div>
))`
  position: absolute;
  width: 100%;
  max-width: 950px;
  img {
    position: absolute;
    right: -80px;
    top: -125px;
  }
  @media only screen and (max-width: 1135px) {
    display: none;
    opacity: 0;
  }
`

const Explainer = styled.p`
  max-width: 780px;
  padding: 0 10px;
  margin: 0 auto;
  font-size: 21px;
  line-height: 30px;
  text-align: justify;
`

const ExplainerGraphic = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  max-width: 780px;
  margin: 0 auto 42px auto;
  img {
    vertical-align: middle;
    margin: 0 10px 0 10px;
  }
`

export default class Home extends Component {
  state = {
    votes: false,
    parties: false,
    downloading: false,
    sort: undefined,
    party: undefined,
    name: undefined,
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.all !== nextProps.all) {
      this.setState({
        votes: false,
        sort: undefined,
        party: undefined,
        name: undefined,
      })
    }
  }

  render({ query, all: aAll }, { votes, downloading }) {
    const all = aAll || getType() !== 'mop'
    const path = all ? '/vsichni' : '/'

    if (!votes && !downloading && typeof window !== 'undefined') {
      this.setState({ downloading: true })
      fetcher({
        path: all ? '/api/votes/all' : '/api/votes',
        onData: v => {
          this.setState({
            votes: v.concat(
              getType() === 'president'
                ? [
                    {
                      id: 6,
                      name: 'Jiří',
                      surname: 'Hynek',
                      party: '',
                      percent: false,
                      is_in_parliament: null,
                    },
                    {
                      id: 9,
                      name: 'Miloš',
                      surname: 'Zeman',
                      party: '',
                      percent: false,
                      is_in_parliament: null,
                    },
                    {
                      id: 2,
                      name: 'Jiří',
                      surname: 'Drahoš',
                      party: '',
                      percent: false,
                      is_in_parliament: null,
                    },
                  ]
                : [],
            ),
            parties: votesToParties(v),
            downloading: false,
          })
        },
      })
    }

    function override(a, b) {
      return a !== undefined ? a : b !== undefined ? b : false
    }

    const name = override(this.state.name, query.name)
    const party = override(this.state.party, query.party)
    const sort =
      override(this.state.sort, query.sort === 'asc' ? -1 : false) || 1

    function sortParam(amp = '') {
      if (sort === 1) return ''
      return `${amp}sort=asc`
    }

    return (
      <Sizer>
        <Title>Podpora opatření</Title>
        <ExplainerGraphic>
          <div>
            <img alt="" src={crossBlack} />proti korupci
          </div>
          <div>
            <img alt="" src={crossBlack} />proti plýtvání veřejnými penězi
          </div>
          <div>
            <img alt="" src={tickBlack} />pro otevřenost veřejné správy
          </div>
        </ExplainerGraphic>
        <Explainer>
          Zeptali jsme se kandidátů{' '}
          {getType() === 'mop' ? 'do Sněmovny' : 'na prezidenta'}, jaká opatření
          podporují a jaká nikoli. V dotazníku jsme uvedli body, na jejichž
          potřebnosti se shodla skupina expertů. Níže uvádíme přehled politiků,
          {all ? '' : ' kteří se do Sněmovny dostali a'} kteří dotazník
          vyplnili.
        </Explainer>

        {!votes ? (
          <Spinner />
        ) : (
          <div>
            <VSpace />
            <Filters>
              {getType() !== 'mop' ? null : (
                <Select
                  value={party}
                  onChange={pty => {
                    if (pty === 'Všechny strany') {
                      replaceState({}, '', path + sortParam('?'))
                      this.setState({ party: false })
                    } else {
                      replaceState(
                        {},
                        '',
                        `${path}?party=${pty}${sortParam('&')}`,
                      )
                      this.setState({ party: pty, name: false })
                    }
                  }}
                  default="Všechny strany"
                  items={[{ key: false, display: 'Všechny strany' }].concat(
                    this.state.parties
                      .sort(
                        (a, b) =>
                          a.count === b.count
                            ? a.party.localeCompare(b.party, 'cs')
                            : a.count < b.count ? 1 : -1,
                      )
                      .map(p => ({
                        key: p.party,
                        display: `${p.party} (${p.count})`,
                      })),
                  )}
                />
              )}
              <NameInput
                placeholder="Jméno politika"
                value={name || ''}
                onChange={evt => {
                  const val = evt.target.value
                  if (val) {
                    replaceState({}, '', `${path}?name=${val}${sortParam('&')}`)
                    this.setState({ name: val, party: false })
                  } else {
                    replaceState({}, '', path + sortParam('?'))
                    this.setState({ name: val })
                  }
                }}
              />
              {getType() !== 'mop' ? null : (
                <label>
                  <ArrowCheckbox
                    checked={sort < 0}
                    type="checkbox"
                    onChange={() => {
                      const newSortParam = (amp = '') =>
                        sort > 0 ? `${amp}sort=asc` : ''
                      if (name) {
                        replaceState(
                          {},
                          '',
                          `${path}?name=${name}${newSortParam('&')}`,
                        )
                      } else if (party) {
                        replaceState(
                          {},
                          '',
                          `${path}?party=${party}${newSortParam('&')}`,
                        )
                      } else {
                        replaceState({}, '', path + newSortParam('?'))
                      }
                      if (sort > 0) {
                        this.setState({ sort: -1 })
                      } else {
                        this.setState({ sort: 1 })
                      }
                    }}
                  />
                </label>
              )}
            </Filters>
            {all || getType() !== 'mop' ? null : <InParliament />}
            <ResultCardContainer>
              {(votes || [])
                .filter(v => !party || v.party === party)
                .filter(
                  v =>
                    !name ||
                    latinize(`${v.name} ${v.surname}`)
                      .toLowerCase()
                      .indexOf(latinize(name).toLowerCase()) > -1,
                )
                .sort(
                  (a, b) =>
                    a.percent === b.percent
                      ? a.surname.localeCompare(b.surname, 'cs')
                      : a.percent < b.percent ? sort : -sort,
                )
                .map(r => <ResultCard {...r} />)}
            </ResultCardContainer>
          </div>
        )}
      </Sizer>
    )
  }
}



// WEBPACK FOOTER //
// ./routes/home/index.js